import { HeadingText } from '@paypalcorp/pp-react'
import React from 'react'
import { Message } from '@paypalcorp/worldready-react'
import { GroupFormFields } from '../create/components/GroupFormFields'
import { MoneyPoolInput } from '../../../../typings'
import { isCoverOnCreateFlowEnabled } from '../../utils/features'
import { useAppDispatch } from '../../store/hooks'
import { toggleUpdateGroup } from '../../store/slices/sheetsSlice'

interface UpdateGroupProps {
  onSubmit: (payload: MoneyPoolInput) => void
}

const UpdateGroup = ({ onSubmit }: UpdateGroupProps) => {
  const dispatch = useAppDispatch()

  const onClickEditImage = () => {
    dispatch(toggleUpdateGroup({ focusOnCoverImageEditButton: false }))
  }

  return (
    <>
      <HeadingText
        as="h1"
        data-testid="updateGroupHeading"
        size={isCoverOnCreateFlowEnabled() ? 'lg' : 'sm'}
      >
        <Message id="update.updateTitle" />
      </HeadingText>
      <GroupFormFields
        handleSubmit={onSubmit}
        onClickEditImage={onClickEditImage}
      />
    </>
  )
}

export default UpdateGroup
